import React from 'react';
import { useTranslation } from 'react-i18next';

const NavigationMenu = ({
  disableSummary,
  summaryAnchor,
  disableConclusion,
  conclusionAnchor,
  disableHearingText,
  hearingTextAnchor,
  disableCommentSection,
  commentSectionAnchor,
}) => {
  const { t: translator } = useTranslation();

  const defaultHref = `${window.location.href}#`;

  const summaryText = translator('hearingProperties.summary');
  const summaryLink = (
    <a
      title={summaryText}
      href={disableSummary ? defaultHref : summaryAnchor}
      className={disableSummary ? '' : 'active-info-flag'}
      id={disableSummary ? 'summary' : 'anchor-summary'}
    >{` ${summaryText} `}</a>
  );

  const conclusionText = translator('hearingProperties.conclusion');
  const conclusionLink = (
    <a
      title={conclusionText}
      href={disableConclusion ? defaultHref : conclusionAnchor}
      className={disableConclusion ? '' : 'active-info-flag'}
      id={disableConclusion ? 'conclusion' : 'anchor-conclusion'}
    >{` ${conclusionText} `}</a>
  );

  const hearingText = translator('hearingProperties.bodyInformation.text');
  const hearingTextLink = (
    <a
      title={hearingText}
      href={disableHearingText ? defaultHref : hearingTextAnchor}
      className={disableHearingText ? '' : 'active-info-flag'}
      id={disableHearingText ? 'hearingText' : 'anchor-hearingText'}
    >{` ${hearingText} `}</a>
  );

  const commentSectionText = translator('pages.hearingDetails.commentReplies');
  const commentSectionLink = (
    <a
      title={commentSectionText}
      href={disableCommentSection ? defaultHref : commentSectionAnchor}
      className={disableCommentSection ? '' : 'active-info-flag'}
      id={disableCommentSection ? 'commentSection' : 'anchor-commentSection'}
    >{` ${commentSectionText} `}</a>
  );

  return (
    <div
      id="menu-outer"
      className={'hearing-section hearing-section-details-menu'}
    >
      <div className="table">
        <ul id="horizontal-list">
          <li>{summaryLink}</li>
          <li>{conclusionLink}</li>
          <li>{hearingTextLink}</li>
          <li>{commentSectionLink}</li>
        </ul>
      </div>
    </div>
  );
};

export { NavigationMenu };
